const levels = {
    error: 0,
    warn: 1,
    info: 2,
    debug: 3,
};
export class Logger {
    transports;
    constructor(opts) {
        this.transports = opts?.transports || [];
    }
    _log(level, message, meta) {
        for (const transport of this.transports) {
            if (levels[transport.level] >= levels[level]) {
                transport.log(message, meta, level);
            }
        }
    }
    debug(message, meta) {
        this._log('debug', message, meta);
    }
    info(message, meta) {
        this._log('info', message, meta);
    }
    log(message, meta) {
        this.info(message, meta);
    }
    warn(message, meta) {
        this._log('warn', message, meta);
    }
    error(message, meta) {
        this._log('error', message, meta);
    }
    addTransport(transport) {
        this.transports.push(transport);
    }
    clearTransports() {
        this.transports = [];
    }
}
const logger = new Logger();
export default logger;
export { ConsoleTransport } from './transports/console.js';
export { DatadogTransport } from './transports/datadog.js';
export { SentryTransport } from './transports/sentry.js';
//# sourceMappingURL=index.js.map